import { ProductGroup } from '~/types/internal-api';
import { QueryOptions, QueryResult } from '../useQuery';
import useCachedQuery from '../useCachedQuery';

/**
 * Custom hook responsible to fetch product groups
 */
export function useProductGroups({ options }: { options?: QueryOptions }): QueryResult<ProductGroup[]> {
    const productGroupsQuery = useCachedQuery<{ data: ProductGroup[] }>(`/products/groups`, [], options);

    return { ...productGroupsQuery, data: productGroupsQuery?.data?.data ?? [] };
}
